import { render } from "./assetmodel.vue?vue&type=template&id=68792896&scoped=true"
import script from "./assetmodel.vue?vue&type=script&lang=js"
export * from "./assetmodel.vue?vue&type=script&lang=js"

import "./assetmodel.vue?vue&type=style&index=0&id=68792896&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68792896"]])

export default __exports__